import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "@/i18n";
import { registerPwaUpdater } from "@/lib/pwaUpdater";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA + drive the "Update available" toast.
registerPwaUpdater();
